<template>
  <div class="side">
    <div class="links">
      <span class="menu">Menu</span>
      <!-- <router-link to="/resources" class="link">resources</router-link> -->
      <router-link to="/visualizers" class="link">Visualizers</router-link>
      <router-link to="/kanbans" class="link">Kanbans</router-link>
      <router-link to="/emails" class="link">Email client</router-link>
      <router-link to="/internal" class="link">Cofocus Internal</router-link>
      <router-link v-if="allowedUser" to="/datamaster" class="link">Data</router-link>
      <router-link v-if="allowedUser" to="/masterboard" class="link">Masterboard</router-link>
      <router-link v-if="allowedUser" to="/flamingo" class="link">Flamingo</router-link>
      <router-link v-if="allowedUser" to="/us" class="link">❤️❤️❤️❤️❤️❤️</router-link>
    </div>
    <CreatorButtons />
  </div>
</template>

<script>
import { mapState } from "vuex";

import CreatorButtons from "./CreatorButtons";
export default {
  name: "SideControls",
  components: {
    CreatorButtons,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      isAuthenticated: (state) => state.auth.authenticationStatus,
    }),
    allowedUser() {
      const allowed_ids = ["60c9fa0c7a094a83b383867b", "60146e6875f16e2295b89cba"];
      if (allowed_ids.includes(this.user._id)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.side {
  display: flex;
  flex-direction: column;
  width: 204px;
  position: absolute;
  left: 5px;
  top: 20px;
}
.links {
  margin-bottom: 15px;
  display: inline-flex;
  flex-direction: column;
  padding: 10px;
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 5px;
  box-shadow: inset 0 -1px 4px 0 rgb(245 244 244 / 67%),
    inset 0 1px 4px 0 hsl(0deg 0% 97% / 62%);
  background-color: #ffffff;
  border: 1px solid hsla(0, 0%, 85.9%, 0.74);
}
.menu {
  font-family: "Nunito", Helvetica, Arial, sans-serif;
  font-size: 18px;
  margin-bottom: 10px;
  font-weight: 600;
}
.link {
  margin: 3px 0;
  font-weight: 600;
  font-size: 17px;
  padding: 0px 16px;
  line-height: 20px;
  height: 34px;
  margin-right: 8px;
  background-color: #fff;
  box-shadow: 0 1px 4px 0 hsl(0deg 0% 86% / 52%);
  color: #2c2c2c;
  border-radius: 360px;
  border: 1px solid #efefef;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: Nunito, Helvetica, Arial, sans-serif;
  outline: none;
  text-decoration: none;
}
.link:hover {
  background-color: #fafafa;
  border-color: #dadada;
}
</style>